import { shuffle } from 'lodash';

export const BUDGET_QUESTION = 'I can no longer afford it / budget reasons';

const unpinnedSurveyQuestions: Array<string> = [
  'I found another solution',
  "I don't need all the tasks/features on this plan",
  'It was too hard or difficult to use',
  'I only needed Zapier temporarily',
  'COVID-19 has affected my business',
  'I upgraded by accident',
  BUDGET_QUESTION,
];

const pinnedSurveyQuestions: Array<string> = ['Other'];

export function downgradeSurveyQuestions(): Array<string> {
  return [...shuffle(unpinnedSurveyQuestions), ...pinnedSurveyQuestions];
}
